import {
  renderTime,
} from '../../userUtils';

const getCommon = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    id: productEventId,
    content,
  } = event;

  const {
    ackRequired,
    productId,
  } = content;

  const {
    criteria,
    warningNumber,
    warnings,
  } = details;

  const severitesByPriority = severities.sort((a, b) => a.priority > b.priority);
  const severity = severitesByPriority.find(((severityByPriority) => {
    for (let i = 0; i < criteria.length; i++) {
      if (criteria[i].severity === severityByPriority.name) {
        return criteria[i].severity;
      }
    }

    return undefined;
  }));

  const {
    name: severityName,
    id: severityId,
  } = severity;

  const latestWarning = warnings[warnings.length - 1];
  const {
    warningVersion: version,
    warningType: status,
    issueTime: originalIssueTime,
  } = latestWarning;

  const issueTime = renderTime(originalIssueTime, userPreferences);

  return {
    productEventId,
    productId,
    status,
    version,
    ackRequired,
    severityName,
    severityId,
    warningNumber,
    issueTime,
  };
};

const getListFeature = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    singularName: productName,
  } = productType;

  const {
    validTime,
    expireTime,
    criteria,
    warningNumber,
  } = details;

  const eventAliases = criteria.map(c => c.eventAlias);
  const criteriaName = eventAliases.join(', ');

  const heading = {
    key: 'PRODUCT_DETAILS.PRODUCT_CARDS.HEADERS.SKYGUARD_WARNINGS',
    params: {
      criteriaName,
      warningNumber,
    },
  };

  const startTime = renderTime(validTime, userPreferences, true);
  const endTime = renderTime(expireTime, userPreferences);

  const subtitle = `${startTime} to ${endTime}`;
  return {
    heading,
    subtitle,
  };
};

const getMapFeature = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    singularName: productName,
  } = productType;
  const {
    expireTime,
    validTime,
    warningNumber,
    warnings,
    criteria,
  } = details;

  const lastWarning = warnings[warnings.length - 1];
  const {
    bbox,
  } = lastWarning;

  const eventAliases = criteria.map(c => c.eventAlias);
  const criteriaName = eventAliases.join(', ');

  const heading = {
    key: 'PRODUCT_DETAILS.PRODUCT_CARDS.HEADERS.SKYGUARD_WARNINGS',
    params: {
      warningNumber,
      criteriaName,
    },
  };

  const subtitle = criteriaName;
  const endTime = renderTime(expireTime, userPreferences);
  const startTime = renderTime(validTime, userPreferences);
  const isPointInTime = false;

  return {
    heading,
    subtitle,
    endTime,
    startTime,
    bbox,
    isPointInTime,
  };
};

const getState = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    state,
  } = event;

  const {
    read,
    acked,
  } = state;

  return {
    read,
    acked,
    playingSound,
  };
};

const getFeatures = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => ({
  map: getMapFeature(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  list: getListFeature(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
});


export default (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const common = getCommon(productType, event, details, playingSound, severities, userPreferences);
  const state = getState(productType, event, details, playingSound, severities, userPreferences);
  const features = getFeatures(productType, event, details, playingSound, severities, userPreferences);

  return { common, state, features };
};
